<template>
  <div style="height: 100vh">
    <div
      style="
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -130px;
        color: white;
        text-align: center;
      "
      :style="{ 'margin-left': '-' + margin + 'px' }"
    >
      <div>
        <img
          :src="'./img/sorry_tuinui.png'"
          alt=""
          style="margin: auto; max-width: 200px"
        />
      </div>
      <h3 ref="message" style="max-width: 200px">{{ message }}</h3>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  props: {
    message: {
      default: "Page not found",
    },
  },
  data: function () {
    return {
      margin: 100,
    };
  },
  mounted: function () {
    var vm = this;
    vm.$nextTick(function () {
      vm.margin = vm.getMargin();
    });
  },
  methods: {
    getMargin: function () {
      return $(this.$refs.message).width() / 2 > 100
        ? $(this.$refs.message).width() / 2
        : 100;
    },
  },
  watch: {
    message: function () {
      this.margin = this.getMargin();
    },
  },
};
</script>

<style scoped></style>
